import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "giorniDa",
})
export class GiorniDaPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value) {
      console.log("[GiorniDaPipe]", value);
      const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
      if (seconds < 300) {
        // less than 300 seconds ago will show as 'Just now'
        return "adesso";
      }
      if (seconds < 86400 && seconds >= 300) {
        return "meno di 1 giorno fa";
      }
      const intervals = {
        anno: 31536000,
        mese: 2592000,
        settimana: 604800,
        giorno: 86400,
        ora: 3600,
        minuto: 60,
        secondo: 1,
      };
      let counter;
      for (const i in intervals) {
        counter = Math.floor(seconds / intervals[i]);
        if (counter > 0)
          if (intervals[i] == 86400) {
            if (counter === 1) {
              return counter + " giorno fa"; // singular (1 day ago)
            } else {
              return counter + " giorni fa"; // plural (2 days ago)
            }
          } else if (intervals[i] == 604800) {
            if (counter === 1) {
              return counter + " settimana fa"; // singular (1 day ago)
            } else {
              return counter + " settimane fa"; // plural (2 days ago)
            }
          } else if (intervals[i] >= 2592000) {
            if (counter === 1) {
              return counter + " mese fa"; // singular (1 day ago)
            } else {
              return counter + " mesi fa"; // plural (2 days ago)
            }
          }
      }
    }
  }
}
